import { useSelector } from 'react-redux';
import { Connection } from '../../redux/slices/connectionsSlice';
import { RootState } from '../../redux/reducers';

export default function useDashboardMember(dashboardMemberId: number): Connection | undefined {
  return useSelector((state: RootState) =>
    state.connections.find((connection) => connection.dashboardMemberId === dashboardMemberId),
  );
}
